import useDataFetcher, { UseDataFetcherReturn } from 'Hooks/Http/useDataFetcher';
import getProfile, { GetUserResponse } from 'Utils/Http/Requests/Profiles/GetProfile';

const useFetchUser = (): UseDataFetcherReturn<GetUserResponse> => {
	return useDataFetcher<GetUserResponse>(getProfile);
};

export default useFetchUser;
